export const VOICE_BARS = [
    42, 70, 36, 88, 54, 64, 32, 76, 46, 84, 38, 66,
    50, 92, 44, 60, 34, 78, 52, 72, 40, 86, 48, 68,
    38, 58, 74, 46, 82, 52, 36, 64, 90, 56, 44, 76,
    60, 32, 68, 84, 48, 72, 40, 62, 88, 54, 34, 70
];

export const VOICE_ACTIVE_COLOR = '#1DA1F2';

export const VOICE_PLAYBACK_SPEEDS = [1, 1.5, 2];

export const formatVoicePlaybackSpeed = (speed) => `${speed}x`;

export const getNextVoicePlaybackSpeed = (speed) => {
    const currentIndex = VOICE_PLAYBACK_SPEEDS.indexOf(speed);
    return VOICE_PLAYBACK_SPEEDS[(currentIndex + 1) % VOICE_PLAYBACK_SPEEDS.length];
};

export const getTranslatedLabel = (t, key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
};

export const formatVoiceTime = (seconds = 0) => {
    const safeSeconds = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
    const mins = Math.floor(safeSeconds / 60);
    const secs = Math.floor(safeSeconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};
